import {FormFields} from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: FormFields = [
  {
    name: "notes",
    title: $t("Note text"),
    type: "textarea",
  }
];
